// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lZ-z","hovered":"mZ-z","hoverImage":"nZ-z","mainImage":"oZ-z","imageNoBackground":"pZ-z","fullSizeImage":"qZ-z"};